import script from "./AnnualReportsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualReportsView.vue?vue&type=script&setup=true&lang=js"

import "./AnnualReportsView.vue?vue&type=style&index=0&id=00e260bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e260bc"]])

export default __exports__